module.exports = __webpack_public_path__ + "static/img/20012 (4).6a2cce9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/20000/20012 (4).jpg
// module id = AbPf
// module chunks = 14